import { graphql } from '@api/mesa'

export const LOGIN_USER = graphql(`
  mutation RequestOTPCode($email: String!) {
    requestOTPCode(requestOtpCodeDto: { email: $email }) {
      requested
    }
  }
`)

export const VERIFY_OTP = graphql(`
  mutation ValidateOTPCode($email: String!, $otpCode: String!) {
    validateOtpCode(validateOtpCode: { email: $email, otpCode: $otpCode }) {
      accessToken
      tokenType
      expiresIn
      refreshToken
    }
  }
`)

export const UPDATE_USER_INFORMATION = graphql(`
  mutation UpdateUserInformation(
    $firstName: String!
    $lastName: String!
    $sourcePartnerName: String
  ) {
    updateUserInformation(
      userInformation: {
        firstName: $firstName
        lastName: $lastName
        sourcePartnerName: $sourcePartnerName
      }
    ) {
      id
      name
      nickname
      phoneNumber
      picture
      lastLogin
      createdAt
      updatedAt
      metadata {
        userTrackingFlag
      }
      firstName
      lastName
      email
      cardInformation {
        lastFour
      }
      sourcePartnerName
    }
  }
`)

export const SEND_PHONE_VERIFICATION_CODE = graphql(`
  mutation SendPhoneVerificationCode($phoneNumber: String!) {
    sendPhoneVerificationCode(sendPhoneVerificationCodeDto: { phoneNumber: $phoneNumber }) {
      success
      status
    }
  }
`)

export const SEND_PHONE_VERIFICATION_CODE_FOR_NEW_ACCOUNT = graphql(`
  mutation SendPhoneVerificationCodeForNewAccount($phoneNumber: String!) {
    sendPhoneVerificationCodeForNewAccount(
      sendPhoneVerificationCodeDto: { phoneNumber: $phoneNumber }
    ) {
      __typename
      ... on SendPhoneVerificationCodeError {
        message
      }
    }
  }
`)

export const VALIDATE_PHONE_VERIFICATION_CODE = graphql(`
  mutation ValidatePhoneVerificationCode($phoneNumber: String!, $code: String!) {
    validatePhoneVerificationCode(
      validatePhoneVerificationCodeDto: { phoneNumber: $phoneNumber, code: $code }
    ) {
      success
      status
    }
  }
`)

export const UPDATE_USER_ADDRESS = graphql(`
  mutation UpdateUserAddress(
    $street1: String!
    $street2: String
    $city: String!
    $state: String!
    $zipCode: String!
  ) {
    updateUserAddress(
      updateUserAddress: {
        street1: $street1
        street2: $street2
        city: $city
        state: $state
        zipCode: $zipCode
      }
    )
  }
`)

export const VALIDATE_AND_UPDATE_HIGHNOTE_ADDRESS = graphql(`
  mutation ValidateAndUpdateHighnoteAddress(
    $streetAddress: String!
    $extendedAddress: String
    $locality: String!
    $region: String!
    $zipCode: String!
  ) {
    validateHighnoteAddress(
      validateAddressRequestDto: {
        streetAddress: $streetAddress
        extendedAddress: $extendedAddress
        locality: $locality
        region: $region
        postalCode: $zipCode
      }
    ) {
      addressValidationOutcome
      standarizedStreetAddress
      standarizedExtendedAddress
      standarizedRegion
      standarizedLocality
      standarizedPostalCode
    }
  }
`)

export const UPDATE_APPS_FLYER_ID = graphql(`
  mutation UpdateAppsFlyerId($appsFlyerId: String!) {
    setAppsFlyerId(input: { appsFlyerId: $appsFlyerId }) {
      __typename
    }
  }
`)
